export default __webpack_public_path__ + "static/media/icon-linkedin.36d7375c.svg";